import * as yup from "yup";

export const validationSchema = yup.object().shape({
  title: yup
    .string()
    .required("İsim alanı zorunludur")
    .min(4, "İsim alanı en az 4 karakterden oluşmalıdır."),
  type: yup.string().required("Tür alanı zorunludur"),
});
